import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const AuditorsComponent = lazy(async () => await import("@/pages/dashboard/control/auditors"))
const AuditorsFormComponent = lazy(async () => await import("@/pages/dashboard/control/auditors/Form"))

export const controlAuditorsRoutes: CustomRoute = {
  path: "auditors",
  handle: { label: "Энергоаудиторы", i18Key: "auditors" },
  children: [
    {
      index: true,
      Component: AuditorsComponent
    },
    {
      path: "create",
      handle: { label: "Добавить новый", i18Key: "create", hideTabs: true },
      Component: AuditorsFormComponent
    },
    {
      path: "edit/:companyId",
      handle: { label: "Редактировать", i18Key: "edit", hideTabs: true },
      Component: AuditorsFormComponent
    }
  ]
}
